import React, { memo, useState, useEffect } from 'react';
import { Row, Col, Select, Button, message, Checkbox } from 'antd';
const { Option } = Select;

import {
  qcParameterFetch,
  enterpriseList,
  postQcParameter,
  qcParameterSelectedFetch,
  courierAccountsFetch
} from '../../actions/sessionActions';

const QcParameter = () => {
  const [state, setState] = useState({
    enterprise: { list: [], selected: null },
    cp: { list: [], cpRawData: null, selectedCp: null },
    accounts: { list: [], selected: [], selectedAccount: null },
    qcParams: { list: [] }
  });

  useEffect(() => {
    pageInit();
  }, []);

  const pageInit = () => {
    enterpriseList('enterprise').then(result => {
      if (result?.meta?.status === 200) {
        setState({
          ...state,
          enterprise: {
            ...state.enterprise,
            list: result.result.enterprises
          }
        });
      }
    });
  };

  const handleChange = (key, value) => {
    const filteredEnterprise = state.enterprise.list.filter(
      item => item.id === value
    );
    state.qcParams.list = [];
    if (key === 'enterprise') {
      // state.cp.list = []

      state.accounts.selectedAccount = null;
      state.cp.selectedCpId = null;
      courierAccountsFetch(filteredEnterprise[0]).then(res => {
        if (res.meta.status === 200) {
          const data = res.result.filter(item => item.is_rvp);
          const cpListData = [];
          const cpName = [];
          data.map(cp => {
            if (cpName.includes(cp.courier_partenr_name) !== true) {
              cpName.push(cp.courier_partenr_name);
              cpListData.push({
                id: cp.account_id,
                name: cp.courier_partenr_name
              });
            }
          });
          setState({
            ...state,
            cp: {
              ...state.cp,
              list: cpListData,
              cpRawData: data
            },
            enterprise: {
              ...state.enterprise,
              selected: value
            }
          });
        }
      });
    }

    if (key === 'cp') {
      state.accounts.selectedAccount = null;
      const filteredAccountsId = state.cp.cpRawData.filter(item => {
        return item.account_id === value;
      });
      const filteredAccountsName = state.cp.cpRawData.filter(item => {
        return item.partner_id === filteredAccountsId[0].partner_id;
      });

      setState({
        ...state,
        cp: {
          ...state.cp,
          selectedCpId: value
        },
        accounts: {
          ...state.accounts,
          selected: filteredAccountsName
        }
      });
    }

    if (key === 'account') {
      setState({
        ...state,
        accounts: {
          ...state.accounts,
          selectedAccount: value
        }
      });
    }
  };

  const getParameter = () => {
    setState({ ...state, qcParams: { list: [] } });
    Promise.all([
      qcParameterFetch(state.accounts.selected[0].partner_id),
      qcParameterSelectedFetch(
        state.enterprise.selected,
        state.accounts.selectedAccount
      )
    ]).then(res => {
      if (res[0].result !== undefined) {
        state.qcParams.list = res[0].result.data.map(item1 => {
          item1 = {
            ...item1,
            start_char_pos: null,
            end_char_pos: null,
            selected: false
          };
          if (res[1].result !== undefined) {
            res[1].result.forEach(item2 => {
              if (item1.field_name === item2.field_name) {
                item1.selected = true;
              }
            });
          }
          return item1;
        });

        setState({
          ...state
        });

        if (res[0].result.data.length === 0) {
          return message.error('No Data Found');
        }
      } else {
        return message.error('No Data Found');
      }
    });
  };

  const handleCheckboxChange = index => {
    state.qcParams.list[index].selected = !state.qcParams.list[index].selected;
    setState({
      ...state
    });
  };
  const submit = () => {
    const ParamData = {
      enterprise_id: state.enterprise.selected,
      account_id: state.accounts.selectedAccount,
      qc_fields: state.qcParams.list.filter(item => item.selected)
    };

    postQcParameter(ParamData).then(result => {
      if (result.meta.status === 200) {
        message.success('QC parameters configured');
      } else {
        message.error(result?.result?.qc_fields?.[0], 4000);
      }
    });
  };
  return (
    <div>
      <h2>Set QC Parameters</h2>
      <Row className="margin-bottom-10">
        <Col span={3}>
          <span>Enterprise:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Select
            name="enterpriseId"
            id="enterpriseId"
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Enterprise"
            optionFilterProp="children"
            onChange={value => handleChange('enterprise', value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {state.enterprise.list.map((enterprise, i) => (
              <Option key={i} value={enterprise.id}>
                {enterprise.name}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={3}>
          <span>Courier Partner:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Select
            name="courierPartner"
            id="courierPartner"
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Courier Partner"
            optionFilterProp="children"
            value={state.cp.selectedCpId}
            onChange={value => handleChange('cp', value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {state.cp.list.map((cp, i) => (
              <Option key={i} value={cp.id}>
                {cp.name}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={3}>
          <span>Account:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Select
            name="Account"
            id="Account"
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Account"
            optionFilterProp="children"
            value={state.accounts.selectedAccount}
            onChange={value => handleChange('account', value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {state.accounts.selected.map((enterprise, i) => (
              <Option key={i} value={enterprise.account_id}>
                {`${enterprise.courier_partenr_name} - ${enterprise.account_code} `}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={24} className="margin-bottom-20  margin-top-20 text-center">
          <Button
            type="primary"
            onClick={getParameter}
            disabled={
              state.accounts.selected.length < 1 ||
              state.accounts.selectedAccount === null ||
              state.cp.selectedCpId === null
                ? true
                : false
            }
          >
            Get Parameter
          </Button>
        </Col>
      </Row>
      {state.qcParams.list.length === 0 ? (
        ''
      ) : (
        <div>
          <Row className="title margin-top-20">QC Parameters</Row>
          <Row>
            <table className={`ant-table ant-table-small width-100pt`}>
              <tbody className="ant-table-tbody">
                {state.qcParams.list.map((value, index) => (
                  <tr key={index}>
                    <td key={value.field_code} className="padding-16">
                      {value.field_name}
                    </td>
                    <td className="text-right">
                      <Checkbox
                        onChange={() => handleCheckboxChange(index)}
                        value={value.field_code}
                        checked={value.selected}
                      ></Checkbox>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Col
              span={24}
              className="margin-bottom-20  margin-top-20 text-center"
            >
              <Button type="primary" onClick={submit}>
                Send
              </Button>
            </Col>
          </Row>{' '}
        </div>
      )}
    </div>
  );
};

export default memo(QcParameter);
